<form [formGroup]="filterForm">
  <div class="filter-container">
    @for (filter of filterConfig; track filter) {
      @if (filter.type === 'select') {
        <mat-form-field class="mb-25">
          <mat-label>{{ filter.label }}</mat-label>
          <mat-select
            [formControlName]="filter.name"
            [multiple]="filter.multiple"
            [placeholder]="filter.placeholder ?? ''">
            @for (option of filter.options; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (filter.type === 'input') {
        <mat-form-field class="mb-25">
          <mat-label>{{ filter.label }}</mat-label>
          <input matInput
            [formControlName]="filter.name"
            [type]="filter.inputType || 'text'"
            [placeholder]="filter.placeholder ?? ''"/>
          </mat-form-field>
        }
        @if (filter.type === 'date') {
          <mat-form-field class="mb-25">
            <mat-label>{{ filter.label }}</mat-label>
            <input matInput
              [formControlName]="filter.name"
              [matDatepicker]="picker"
              [placeholder]="filter.placeholder ?? ''"/>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          }
        }

        <button mat-icon-button matTooltip="Resetiraj kriterij pretrage" type="button" (click)="resetFilters()">
          <mat-icon>refresh</mat-icon>
        </button>

      </div>
    </form>